export default __webpack_public_path__ + "static/media/SYS.ace00ac5.svg";